import { COLLISION_COLOURS, COLLISION_GROUPS } from '../../../constants/Constants';
import { GameEvents } from '../../GameEvents';
import { CollisionCollider } from '../collisions/CollisionCollider';

export class WorldCoin extends SpinePlugin.SpineGameObject {
  constructor(scene, layer, model) {
    super(scene, scene.spine, model.x, model.y, 'coin', 'idle');
    scene.add.existing(this);
    layer.add(this);
    this.type = 'coin';
    this._bodyCollider = new CollisionCollider(this.scene, {
      x: this.x - 24,
      y: this.y - 24,
      width: 48,
      height: 48,
      gameObject: this,
      sensor: true,
      debugColour: COLLISION_COLOURS.COIN,
      collisionGroup: COLLISION_GROUPS.COIN,
      collidesWith: COLLISION_GROUPS.HERO_BODY,
    });
  }

  setVelocity(x, y) {
    this._velocity = { x, y };
  }

  update(time, delta) {
    if (this.persist) return;
    delta /= 1000;
    this.life -= delta;
    if (this.life < 0) this.destroy();
  }

  collect() {
    if (this.collected) return;
    this.collected = true;
    this._bodyCollider.enabled = false;
    this.scene.events.emit(GameEvents.COLLECT_COIN, this);
    this.once('complete', this.destroy, this);
    this.play('collect');
  }

  destroy() {
    if (this._bodyCollider) {
      this._bodyCollider.destroy();
      this._bodyCollider = null;
    }
    super.destroy();
  }
}
